import { Component, Input, SimpleChanges, OnChanges, Output, EventEmitter } from "@angular/core";
import { tap } from "rxjs/operators";
import { Message } from "../models/message";
import { ExternalEditGridComponent } from 'src/app/core/external-edit-grid.component';
import { Connection } from '../models/connection';
import { MessageStore, MessageStoreScope } from '../models/message-store';
import { QueueMessageDataService, QueueDeadLetterMessageDataService, SubscriptionMessageDataService, SubscriptionDeadLetterMessageDataService, TopicMessageDataService } from '../services/message-data.service';
import { PageChangeEvent } from '@progress/kendo-angular-grid';
import { QueueMessage } from '../models/queue-message';
import { SubscriptionMessage } from '../models/subscription-message';
import { TopicMessage } from '../models/topic-message';
import { HttpHeaders } from '@angular/common/http';

@Component({
  selector: "app-messages",
  templateUrl: "./messages.component.html",
  styleUrls: ["./messages.component.scss"],
})
export class MessagesComponent extends ExternalEditGridComponent<Message> implements OnChanges {
  constructor(
    private queueMessageDataService: QueueMessageDataService,
    private queueDlqMessageDataService: QueueDeadLetterMessageDataService,
    private subMessageDataService: SubscriptionMessageDataService,
    private subDlqMessageDataService: SubscriptionDeadLetterMessageDataService,
    private topicMessageDataService: TopicMessageDataService) {
    super(Message);
  }

  private baselineSequenceNbr: number = 0;
  public isOpen: boolean;
  public buttonCount = 5;
  public info = true;
  public type: 'numeric';
  public pageSizes = true;
  public previousNext = true;
  public pageSize = 5;
  public skip = 0;

  @Input() public connection: Connection;
  @Input() public store: MessageStore;
  @Input() public scope: MessageStoreScope;
  @Input() public open: boolean;
  @Output() delete: EventEmitter<any> = new EventEmitter();
  @Output() resubmit: EventEmitter<any> = new EventEmitter();

  ngOnInit() {
    super.ngOnInit(false);
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.open === undefined)
      return;

    let opening = !this.isOpen && changes.open.currentValue;
    this.isOpen = changes.open.currentValue;

    if (opening)
      this.refresh();
  }

  protected refresh() {
    let headers = new HttpHeaders({ 'sequenceNbr': this.baselineSequenceNbr.toString()});
    if (this.scope == MessageStoreScope.Queue) {
      this.view = this.queueMessageDataService
      .get(this.gridState, `&$filter=connectionId eq ${this.connection.Id} and Queue eq '${this.store.Name}'&$expand=UserProperties&$orderby=EnqueuedAt`, headers)
      .pipe(tap((r) => {
        if (this.gridState.skip == 0 && r.data.length > 0){
          this.baselineSequenceNbr = r.data[0].SequenceNumber;
        }
        this.loading = false;
      }));
    } else if (this.scope == MessageStoreScope.QueueDeadLetter) {
      this.view = this.queueDlqMessageDataService
      .get(this.gridState, `&$filter=connectionId eq ${this.connection.Id} and Queue eq '${this.store.Name}'&$expand=UserProperties&$orderby=EnqueuedAt`, headers)
      .pipe(tap((r) => {
        if (this.gridState.skip == 0 && r.data.length > 0){
          this.baselineSequenceNbr = r.data[0].SequenceNumber;
        }
        this.loading = false;
      }));     
    } else if (this.scope == MessageStoreScope.Subscription) {
      this.view = this.subMessageDataService
      .get(this.gridState, `&$filter=connectionId eq ${this.connection.Id} and Topic eq '${this.store.Topic}' and Subscription eq '${this.store.Name}'&$expand=UserProperties&$orderby=EnqueuedAt`, headers)
      .pipe(tap((r) => {
        if (this.gridState.skip == 0 && r.data.length > 0){
          this.baselineSequenceNbr = r.data[0].SequenceNumber;
        }
        this.loading = false;
      }));      
    } else if (this.scope == MessageStoreScope.SubscriptionDeadLetter) {
      this.view = this.subDlqMessageDataService
      .get(this.gridState, `&$filter=connectionId eq ${this.connection.Id} and Topic eq '${this.store.Topic}' and Subscription eq '${this.store.Name}'&$expand=UserProperties&$orderby=EnqueuedAt`, headers)
      .pipe(tap((r) => {
        if (this.gridState.skip == 0 && r.data.length > 0){
          this.baselineSequenceNbr = r.data[0].SequenceNumber;
        }
        this.loading = false;
      }));     
    }

  }

  public saveHandler(message: Message) {
  } 
  
  public deleteHandler(message: Message) {
    this.editItem = undefined;

    if (this.scope == MessageStoreScope.QueueDeadLetter) {
      let qm : QueueMessage = new QueueMessage();
      qm.Id = message.Id;
      qm.ConnectionId = this.store.ConnectionId;
      qm.Queue = this.store.Name;
      this.refreshObservable(this.queueDlqMessageDataService.deleteMessage(qm));
      this.delete.emit();    
    } else if (this.scope == MessageStoreScope.SubscriptionDeadLetter) {
      let sm : SubscriptionMessage = new SubscriptionMessage();
      sm.Id = message.Id;
      sm.ConnectionId = this.store.ConnectionId;
      sm.Subscription = this.store.Name;
      sm.Topic = this.store.Topic;
      this.refreshObservable(this.subDlqMessageDataService.deleteMessage(sm));
      this.delete.emit();    
    }
  } 

  public resubmitHandler(message: Message) {
    this.editItem = undefined;

    if (this.scope == MessageStoreScope.QueueDeadLetter) {
      let qm : QueueMessage = new QueueMessage();
      qm.Id = message.Id;
      qm.ConnectionId = this.store.ConnectionId;
      qm.Queue = this.store.Name;
      qm.Body = message.Body;
      qm.SequenceNumber = 0;
      qm.Size = 0;
      qm.EnqueuedAt = new Date();
      qm.UserProperties = [];
      this.queueDlqMessageDataService.deleteMessage(qm)
        .subscribe(r => {
          this.refreshObservable(this.queueMessageDataService.addMessage(qm));
        }); 
    } else if (this.scope == MessageStoreScope.SubscriptionDeadLetter) {
      let sm : SubscriptionMessage = new SubscriptionMessage();
      sm.Id = message.Id;
      sm.ConnectionId = this.store.ConnectionId;
      sm.Subscription = this.store.Name;
      sm.Topic = this.store.Topic;
      sm.Body = message.Body;
      sm.SequenceNumber = 0;
      sm.Size = 0;
      sm.EnqueuedAt = new Date();
      sm.UserProperties = [];
      this.subDlqMessageDataService.deleteMessage(sm)
        .subscribe(r => {
          let tm: TopicMessage = new TopicMessage();
          tm.Id = sm.Id;
          tm.Body = sm.Body;
          tm.Topic = sm.Topic;
          tm.ConnectionId = sm.ConnectionId;
          this.refreshObservable(this.topicMessageDataService.addMessage(tm));
        }); 
    }  
  } 

  public removeHandler({ dataItem }) {
  }

  protected pageChange({ skip, take }: PageChangeEvent): void {
    this.skip = skip;
    this.pageSize = take;
  }  
}
